import * as React from "react";
import { FixedSizeList } from "react-window";
import { styled } from "@mui/material/styles";

const LISTBOX_PADDING = 8;

const StyledListbox = styled("div")(({ theme }) => ({
  boxSizing: "border-box",
  padding: theme.spacing(1),
}));

const VirtualizedListbox = React.forwardRef(function VirtualizedListbox(
  props,
  ref
) {
  const { children, ...other } = props;
  const items = React.Children.toArray(children);
  const ITEM_COUNT = items.length;
  const ITEM_SIZE = 36;
  const MAX_CONTAINER_HEIGHT = 400;

  return (
    <StyledListbox ref={ref} {...other}>
      <FixedSizeList
        height={Math.min(
          MAX_CONTAINER_HEIGHT,
          ITEM_SIZE * ITEM_COUNT + LISTBOX_PADDING
        )}
        itemCount={ITEM_COUNT}
        itemSize={ITEM_SIZE}
        width="100%"
      >
        {({ index, style }) => (
          <div style={style} key={index}>
            {items[index]}
          </div>
        )}
      </FixedSizeList>
    </StyledListbox>
  );
});

export default VirtualizedListbox;
